import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import { Users, ClipboardList, Timer, CheckCircle2, XCircle, Wallet } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, PieChart, Pie, Cell, Legend } from "recharts";

const monthly = Array.from({ length: 12 }).map((_, i) => ({ m: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][i], apps: 20 + Math.round(Math.random() * 50), disb: 10 + Math.round(Math.random() * 40) }));

export default function AdminDashboard() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  const pie = [
    { name: "Approved", value: s.approved || 0 },
    { name: "Pending", value: s.pending || 0 },
    { name: "Rejected", value: s.rejected || 0 },
  ];
  const COLORS = ["#4F46E5", "#8B5CF6", "#F43F5E"];
  return (
    <AdminLayout>
      <div className="space-y-8" data-testid="admin-dashboard">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Overview</div>
          <h1 className="font-display text-3xl mt-2">Admin Console</h1>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          <Stat icon={Users} k="Customers" v={s.total_users || 0} />
          <Stat icon={ClipboardList} k="Applications" v={s.total_loans || 0} />
          <Stat icon={Timer} k="Pending" v={s.pending || 0} />
          <Stat icon={CheckCircle2} k="Approved" v={s.approved || 0} />
          <Stat icon={XCircle} k="Rejected" v={s.rejected || 0} />
          <Stat icon={Wallet} k="Disbursed" v={`₹${Number(s.disbursed_total || 0).toLocaleString("en-IN")}`} />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <Card className="lg:col-span-2 p-6">
            <div className="font-display text-xl mb-4">Applications vs disbursals</div>
            <div className="h-64">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={monthly}>
                  <XAxis dataKey="m" stroke="hsl(var(--muted-foreground))" fontSize={12} />
                  <YAxis stroke="hsl(var(--muted-foreground))" fontSize={12} />
                  <Tooltip />
                  <Bar dataKey="apps" fill="#4F46E5" radius={[6,6,0,0]} />
                  <Bar dataKey="disb" fill="#8B5CF6" radius={[6,6,0,0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Card>
          <Card className="p-6">
            <div className="font-display text-xl mb-4">Status split</div>
            <div className="h-64">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={pie} innerRadius={50} outerRadius={90} paddingAngle={4} dataKey="value">
                    {pie.map((_, i) => <Cell key={i} fill={COLORS[i]} />)}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </div>
      </div>
    </AdminLayout>
  );
}
function Stat({ icon: Icon, k, v }) {
  return (
    <Card className="p-5">
      <div className="flex items-center justify-between"><div className="text-xs uppercase tracking-widest text-muted-foreground">{k}</div><Icon className="h-4 w-4 text-primary" /></div>
      <div className="font-display text-2xl mt-3">{v}</div>
    </Card>
  );
}
